import { useTransactions } from 'contexts/Transactions';
import React from 'react';
import { Skeleton } from '@mui/material';
import { TableFilters } from './TableFilters';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TableSearch from './TableSearch';
import { TableShowMore } from './TableShowMore';

const TableTransactions = () => {
  const { isEmpty, loading } = useTransactions();

  return (
    <div className="beneficiaries-table-wrapper" data-testid="test-table-beneficiaries">
      <>
        <TableSearch />
        <TableFilters />
      </>
      {!loading ? (
        <>
          <div className="container-table-beneficiaries">
            <table>
              <tbody>
                {!isEmpty && <TableHeader />}
                <TableRow />
              </tbody>
            </table>
          </div>
          {!isEmpty && <TableShowMore />}
        </>
      ) : (
        <>
          <div className="batch-skeleton-text">
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
            <Skeleton height={64} />
          </div>
          <div className="batch-skeleton-btn">
            <Skeleton height={64} />
          </div>
        </>
      )}
    </div>
  );
};

export default TableTransactions;
